$(() =>  {
  if ($('form.edit_user, form.new_user').length > 0) {
    var form = $('form.edit_user, form.new_user')
    form.find('#user_payor_ids').select2()
    form.find('#user_school_ids').select2()
    form.find('#user_adjunct_notification_attributes_event_list').select2()
  }
})
